<template>
    <div class="content">
      <form @submit="handleSubmit">
        <div :class="this.dragging ? 'active-dropzone' : 'dropzone'" 
          @dragenter.prevent ="toggleActive"
          @dragleave.prevent="toggleActive"
          @dragover.prevent
          @drop.prevent="dropImage" @click="findInput()">
          <span class="dragndrop-text" v-if="!this.dragging && !this.hasImage">Clique ou arraste uma imagem</span>
          <span class="dragndrop-text" v-if="this.dragging">Solte sua imagem aqui</span>
          <img class="preview-img" :src="preview" />
        </div>
        <image-uploader
          :preview="false"
          outputFormat="blob"
          capture="environment"
          :maxWidth="300"
          :debug="1"
          :autoRotate="true"
          ref="file"
          @input="setImage"
        >
        </image-uploader>

        <span v-if="image" style="text-align:center; color:var(--text-main); opacity:.9;"> {{ this.fileName }} </span>
        <button @click.prevent="handleSubmit" class="button btn-primary" v-if="!loading">
          <span v-if="customer.profile_picture != null">Alterar</span>
          <span v-else>Adicionar</span>
        </button>
      </form>
    </div>
</template>

<script>
  import {GET_CUSTOMER, POST_CUSTOMER} from '../../services/customer';

  import { library } from '@fortawesome/fontawesome-svg-core'
  import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

  import ImageUploader from 'vue-image-upload-resize'

  library.add(faTrashAlt);

  export default {
    props: ['values'],
    name: "edit-picture",
    components: { ImageUploader },
    
    data() {
          return {
            fileName: null,
            image: null,
            loading: false,
            loadingScreen: false,
            customer: {},
            errors: [],
            profile_picture: null,
            preview: null,
            dragging: false,
            hasImage: false,
            form: {
                name: "",
                email: "",
                birth_date: "",
                cpf: "",
                gender: null,
                ethnicity: null,
                cellphone: "",
                cep: "",
                uf: "",
                city: "",
                street: "",
                number: "",
                district: "",
                status: "",
                password: "",
                password_confirmation: "",
                first_acess: 0,
                profile_picture: null,
            },

          }
        },
    methods: {
      setImage: function (input) {
        this.image = input;
        this.fileName = document.getElementById("fileInput").files[0]['name'];
        this.hasImage = true;
        this.preview = URL.createObjectURL(this.image);
      },

      dropImage: function(input) {
        this.image = input.dataTransfer.files[0];
        this.fileName = this.image.name;
        this.hasImage = true;
        this.toggleActive();
        this.preview = URL.createObjectURL(this.image);
      },

      toggleActive(){
        this.dragging = !this.dragging;
      },

      findInput(){
        document.getElementById('fileInput').click()
      },

      outsideClick() {
          if(event.target === event.currentTarget)
              this.$emit('close');
      },
      clean(obj) {
          for (var propName in obj) {
              if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "") {
                  delete obj[propName];
              }
          }
          return obj
      },

      async getCustomer() {
        this.$emit('setLoadingScreen', true);

        try {
          const data = await GET_CUSTOMER();
          this.customer = data.customer;

          if (!!this.customer.profile_picture){
            this.profile_picture = this.customer.profile_picture;
          }

        } catch(error) {
          console.log(error);
        } finally {
        this.$emit('setLoadingScreen', false);
        }
      },

      handleSubmit() {
        let form = new FormData();
        form.append('profile_picture', this.image, this.image.name);
        this.loading = true;
        POST_CUSTOMER(form).then(r => {
            this.loading = false;
            this.errors = null;
            this.getCustomer();
            this.$emit('updateCustomer', this.customer);
        }, err => {
            this.errors = err.response.data;
            this.loading = false;
        });
      },
  },

  mounted() {
      this.getCustomer();
    }
  }
</script>

<style scoped>
  .btn-primary{
    margin-top: 1rem;
  }

  .dropzone{
    display: flex;
    justify-content: center;
    width: 100%;
    min-height: 300px;
    max-height: 350px;
    background-color: var(--bg-aux-white);
    border-radius: 10px;
    cursor: pointer;
    margin-bottom: 1rem;
    border: 2px dashed var(--secondary-color);
  }

  .active-dropzone{
    display: flex;
    justify-content: center;
    width: 100%;
    min-height: 300px;
    max-height: 350px;
    background-color: var(--secondary-color);
    border-radius: 12px;
    cursor: pointer;
    opacity: .8;
    color: var(--light);
    margin-bottom: 1rem;
    border: 2px dashed var(--bg-aux-white)
  }

  .preview-img{
    min-height: 100%;
    max-width: 240px;
    max-height: 100%;
    border: 0 !important;
    object-fit: cover;
  }

  .dragndrop-text{
    position:absolute;
    top: 45%;
  }

</style>



// WEBPACK FOOTER //
// src/components/CardHealthId/EditPicture.vue